import EmptyStudies from './EmptyStudies';
export default EmptyStudies;
